import { SelectOption } from '~/definitions/admin';

export const formatSelectOptions = (options: any[]): SelectOption[] => {
    return (
        options?.map((option) => {
            return { value: option.id, label: option.name };
        }) || []
    );
};
